import { BodyText } from "@classdojo/web/nessie";
import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import { translate } from "@classdojo/web/utils/translate";
import { Link } from "react-router-dom";
import NoWebkitOverflowScrolling from "./NoWebkitOverflowScrolling";
import Video from "src/pods/ideas/components/video/Video";
import { Slide } from "src/pods/ideas/data/types";

type PhoneWatchVideoProps = {
  watch: Slide;
  canPlayOnComputer?: boolean;
  onPlayOnComputer: VoidFunction;
};

function PhoneWatchVideo({ watch, canPlayOnComputer, onPlayOnComputer }: PhoneWatchVideoProps) {
  return (
    <article sx={pageStyle}>
      <section sx={cardStyle}>
        <NoWebkitOverflowScrolling />
        <div sx={videoContainerStyle}>
          <Video type={watch.type} watch={watch} autoplay={false} />
          <div sx={stateStyle}>
            <BodyText sx={{ marginY: "dt_s" }}>{translate("dojo.toolkit:mojo_show.video.playing_on_phone")}</BodyText>
            {canPlayOnComputer && (
              <a
                data-name="phone_watch_video:mojo_show_video_play_on_computer"
                href="#"
                sx={playOnPhoneInstead}
                onClick={(e) => {
                  e.preventDefault();
                  onPlayOnComputer();
                }}
              >
                {translate("dojo.toolkit:mojo_show.video.play_on_computer")}
              </a>
            )}
            {!canPlayOnComputer && (
              <Link to="/apps/help/what-is-dojocast" sx={playOnPhoneInstead}>
                {translate("dojo.toolkit:mojo_show.video.play_on_computer")}
              </Link>
            )}
          </div>
        </div>
      </section>
    </article>
  );
}

export default PhoneWatchVideo;

const pageStyle: ThemeUIStyleObject = {
  fontSize: "28px",
};

const videoContainerStyle: ThemeUIStyleObject = {
  paddingLeft: RAW_cssValue(20),
  paddingRight: RAW_cssValue(20),
  marginTop: "dt_l",
};

const cardStyle: ThemeUIStyleObject = {
  maxWidth: "864px",
  margin: "auto",
  textAlign: "center",
};

const stateStyle: ThemeUIStyleObject = {
  marginBottom: RAW_cssValue(20),
  marginTop: RAW_cssValue(20),
};

const playOnPhoneInstead: ThemeUIStyleObject = {
  color: "dt_content_plus",
  fontWeight: 600,
  fontSize: 20,
};
